import { useNavigate } from "@tanstack/react-router";
import { PlusIcon } from "lucide-react";
import { Button } from "../../../ui/button/button";
import { CardSVG } from "../../../ui/icons";

export type PageStep = "add" | "card" | "select";

type Props = {
	type?: "card" | "deposit";
	setPageStep: React.Dispatch<React.SetStateAction<PageStep>>;
};

const AddCreditCard: React.FC<Props> = ({ type = "card", setPageStep }) => {
	const navigate = useNavigate();
	return (
		<div className="m-4 p-4 px-6 bg-primary-50 rounded-3xl">
			<div className="flex flex-col items-center mb-4 space-y-6">
				<CardSVG />
				<div className="flex flex-col items-center w-full">
					<h2 className="text-2xl font-bold text-textDark">
						Add a credit card
					</h2>
					<p className="mt-1 text-sm font-medium leading-6 text-center text-textLight">
						Start converting your <br />
						available credit limit into <br /> spendable cash.
					</p>
				</div>
				<Button
					variant="default"
					size="md"
					onClick={() => {
						if (type === "card") {
							navigate({
								to: "/main/card/new",
							});
						} else {
							setPageStep("select");
						}
					}}
				>
					<PlusIcon /> Add a Credit Card
				</Button>
			</div>
		</div>
	);
};

export default AddCreditCard;
